<template>
  <div class="rainbow entryBtn mb-4" @click="click">
    <div class="entryBtn_icon">
      <!-- <img
        @error="errorImg"
        v-if="onlineIcon"
        :src="onlineIcon && hasIcon"
        alt
      /> -->
      <img
        v-if="!onlineIcon && hasIcon"
        :src="
          require(`../assets/${
            localIcon || 'foreignLicense.png' || 'Circle.png'
          }`)
        "
        alt
      />
    </div>
    <div class="entryBtn_value">{{ label }}</div>

    <m-icon class="entryBtn_right" type="right" />
  </div>
</template>

<script>
export default {
  props: ['icon', 'label', 'path', 'onlineIcon', 'localIcon', 'hasIcon'],
  data() {
    return {
      isIE: false,
      active: false,
      env: process.env.NODE_ENV,
    };
  },
  computed: {},
  methods: {
    // errorImg(e) {
    //   const img = e.srcElement;
    //   img.src = require('../assets/foreignLicense.png');
    //   img.onerror = null; // 防止闪图
    // },
    showActive(bool) {
      this.active = bool;
    },
    click() {
      this.$emit('click');
    },
  },
  created() {
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      this.isIE = true;
    } else {
      this.isIE = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.entryBtn {
  border-radius: 10px;
  padding: 20px 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.entryBtn_icon {
  max-width: 50px;
  position: relative;
  border-radius: 100px;
  overflow: hidden;
  margin-right: 12px;
}
.entryBtn_icon img {
  width: 100%;
  display: block;
  margin: auto;
}
.entryBtn_value {
  line-height: 50px;
  font-weight: 600;
  color: var(--text-white-color);
}
.entryBtn_right {
  position: absolute;
  right: 16px;
  color: var(--text-white-color);
}
</style>
